import React, { useEffect, useState } from 'react';
import './header.scss';
import { env } from '../../environment';
import { useLocation } from 'react-router-dom';
import { Dropdown } from 'primereact/dropdown';
import { LanguageCode, LanguageList, getLanguageDefault } from '../../utils/Utils';
import { withTranslation } from 'react-i18next';

const Header = (props: any) => {
  const { t, i18n } = props;
  const [header, setHeader] = useState<any>(null);
  const [language, setLanguage] = useState(getLanguageDefault() || LanguageList[1]);
  const [languages, setLanguages] = useState(getLanguageDefault()?.code === LanguageCode.DE ? [...LanguageList].reverse() : LanguageList);
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);

  // const getHeader = async () => {
  //   try {
  //     const { data: header } = await HeaderManagerAPI.getHeaderAPI();
  //     const headerConvert = JSON.parse(
  //       header.records.filter((f: any) => f.is_primary !== true)[0].parameters
  //     );

  //     setHeader(headerConvert);
  //   } catch (error) {
  //     setHeader({});
  //   }
  // };

  // useEffect(() => {
  //   getHeader();
  // }, []);

  // const navigateToCMSPage = () => {
  //   window.open(`${env.CMS_URL}`, '_blank');
  // }

  const onLanguageChange = (e: any) => {
    localStorage.setItem('language_code', e.value.code.toLowerCase());
    i18n.changeLanguage(e.value.code.toLowerCase());
    const newUrl = `${location.pathname}?lang=${e.value.code.toLowerCase()}`;
    queryParams.set('lang', e.value.code.toLowerCase());
    setLanguage(e.value);
    setLanguages(e.value?.code === LanguageCode.DE ? [...LanguageList].reverse() : LanguageList);
    window.history.pushState({}, '', newUrl);
  };

  const itemTemplateCustom =
    (isMobile = false) =>
    (rowData: any) => {
      return (
        <React.Fragment>
          {rowData.code === LanguageCode.EN ? (
            isMobile ? (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_4132_29579" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                  <path
                    d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_4132_29579)">
                  <path d="M23.649 -6.32422H8.34961V38.3245H23.649V-6.32422Z" fill="white" />
                  <path d="M33.7404 -6.32422H23.6299V38.3245H33.7404V-6.32422Z" fill="#EC2224" />
                  <path d="M8.37028 -6.32422H-1.74023V38.3245H8.37028V-6.32422Z" fill="#EC2224" />
                  <path
                    d="M15.9998 8.5918L14.8018 10.8266C14.6657 11.0694 14.422 11.0467 14.1783 10.9111L13.3112 10.4634L13.9573 13.8966C14.0933 14.524 13.6574 14.524 13.442 14.2515L11.9279 12.556L11.6837 13.4158C11.6627 13.486 11.6161 13.5458 11.5532 13.5834C11.4902 13.621 11.4155 13.6337 11.3437 13.6189L9.42978 13.217L9.93245 15.045C10.0401 15.4513 10.1243 15.62 9.82389 15.7273L9.1416 16.0477L12.4366 18.7245C12.5028 18.7767 12.5522 18.847 12.5788 18.9269C12.6055 19.0067 12.6082 19.0926 12.5866 19.174L12.298 20.1201C13.4337 19.9893 14.4491 19.7927 15.5843 19.6706C15.6846 19.6597 15.8524 19.8254 15.8516 19.9418L15.7016 23.4086H16.2527L16.1655 19.9487C16.1655 19.8323 16.3172 19.6597 16.4175 19.6706C17.551 19.7918 18.5698 19.9884 19.7033 20.1201L19.4152 19.1736C19.3936 19.0923 19.3963 19.0065 19.4229 18.9267C19.4495 18.847 19.4988 18.7767 19.5647 18.7245L22.8593 16.0477L22.177 15.7268C21.8766 15.6196 21.959 15.4513 22.0685 15.0445L22.5711 13.2165L20.6568 13.6189C20.585 13.6335 20.5103 13.6207 20.4475 13.5831C20.3846 13.5454 20.3381 13.4856 20.3172 13.4153L20.0713 12.556L18.5576 14.2511C18.3423 14.5218 17.9059 14.5218 18.0419 13.8962L18.6884 10.4634L17.8213 10.9129C17.5776 11.048 17.3339 11.0711 17.1978 10.8257"
                    fill="#EC2224"
                  />
                </g>
              </svg>
            ) : (
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <mask id="mask0_4132_2957" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
                  <path
                    d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_4132_2957)">
                  <path d="M23.649 -6.32422H8.34961V38.3245H23.649V-6.32422Z" fill="white" />
                  <path d="M33.7404 -6.32422H23.6299V38.3245H33.7404V-6.32422Z" fill="#EC2224" />
                  <path d="M8.37028 -6.32422H-1.74023V38.3245H8.37028V-6.32422Z" fill="#EC2224" />
                  <path
                    d="M15.9998 8.5918L14.8018 10.8266C14.6657 11.0694 14.422 11.0467 14.1783 10.9111L13.3112 10.4634L13.9573 13.8966C14.0933 14.524 13.6574 14.524 13.442 14.2515L11.9279 12.556L11.6837 13.4158C11.6627 13.486 11.6161 13.5458 11.5532 13.5834C11.4902 13.621 11.4155 13.6337 11.3437 13.6189L9.42978 13.217L9.93245 15.045C10.0401 15.4513 10.1243 15.62 9.82389 15.7273L9.1416 16.0477L12.4366 18.7245C12.5028 18.7767 12.5522 18.847 12.5788 18.9269C12.6055 19.0067 12.6082 19.0926 12.5866 19.174L12.298 20.1201C13.4337 19.9893 14.4491 19.7927 15.5843 19.6706C15.6846 19.6597 15.8524 19.8254 15.8516 19.9418L15.7016 23.4086H16.2527L16.1655 19.9487C16.1655 19.8323 16.3172 19.6597 16.4175 19.6706C17.551 19.7918 18.5698 19.9884 19.7033 20.1201L19.4152 19.1736C19.3936 19.0923 19.3963 19.0065 19.4229 18.9267C19.4495 18.847 19.4988 18.7767 19.5647 18.7245L22.8593 16.0477L22.177 15.7268C21.8766 15.6196 21.959 15.4513 22.0685 15.0445L22.5711 13.2165L20.6568 13.6189C20.585 13.6335 20.5103 13.6207 20.4475 13.5831C20.3846 13.5454 20.3381 13.4856 20.3172 13.4153L20.0713 12.556L18.5576 14.2511C18.3423 14.5218 17.9059 14.5218 18.0419 13.8962L18.6884 10.4634L17.8213 10.9129C17.5776 11.048 17.3339 11.0711 17.1978 10.8257"
                    fill="#EC2224"
                  />
                </g>
              </svg>
            )
          ) : isMobile ? (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip_mobile_0_4132_2966)">
                <path
                  d="M0 27.0774C0 28.3831 0.374602 29.6353 1.0414 30.5585C1.70819 31.4818 2.61256 32.0005 3.55556 32.0005H28.4444C29.3874 32.0005 30.2918 31.4818 30.9586 30.5585C31.6254 29.6353 32 28.3831 32 27.0774V22.1543H0V27.0774Z"
                  fill="#FFCD05"
                />
                <path d="M0 11.0771H32V22.1541H0V11.0771Z" fill="#ED1F24" />
                <path
                  d="M28.4444 0H3.55556C2.61256 0 1.70819 0.51868 1.0414 1.44194C0.374602 2.36519 0 3.6174 0 4.92308L0 11.0769H32V4.92308C32 3.6174 31.6254 2.36519 30.9586 1.44194C30.2918 0.51868 29.3874 0 28.4444 0Z"
                  fill="#141414"
                />
              </g>
              <defs>
                <clipPath id="clip_mobile_0_4132_2966">
                  <rect width="32" height="32" rx="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4132_2966)">
                <path
                  d="M0 27.0774C0 28.3831 0.374602 29.6353 1.0414 30.5585C1.70819 31.4818 2.61256 32.0005 3.55556 32.0005H28.4444C29.3874 32.0005 30.2918 31.4818 30.9586 30.5585C31.6254 29.6353 32 28.3831 32 27.0774V22.1543H0V27.0774Z"
                  fill="#FFCD05"
                />
                <path d="M0 11.0771H32V22.1541H0V11.0771Z" fill="#ED1F24" />
                <path
                  d="M28.4444 0H3.55556C2.61256 0 1.70819 0.51868 1.0414 1.44194C0.374602 2.36519 0 3.6174 0 4.92308L0 11.0769H32V4.92308C32 3.6174 31.6254 2.36519 30.9586 1.44194C30.2918 0.51868 29.3874 0 28.4444 0Z"
                  fill="#141414"
                />
              </g>
              <defs>
                <clipPath id="clip0_4132_2966">
                  <rect width="32" height="32" rx="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          )}
        </React.Fragment>
      );
    };

  useEffect(() => {
    const lang = queryParams.get('lang') || 'de';
    localStorage.setItem('language_code', lang || 'de');
    i18n.changeLanguage(lang || 'de');
    const _language = LanguageList.find(item => item.code.toLowerCase() === lang);
    setLanguage(_language || LanguageList[0]);
    setLanguages(_language?.code === LanguageCode.DE ? [...LanguageList].reverse() : LanguageList);
  }, []);

  return (
    <header id="abw_main_header">
      <div className="aw_inner_header aw_max_content_width">
        <div className="aw_logo ml_mobile_24">
          <a href={`${env.CMS_URL}`} target="_blank" rel="noreferrer">
            <picture>
              <source
                media="(min-width: 721px)"
                srcSet={`${env.MEDIA_URL}/static-images/wilderness-main-logo.svg 164w`}
                sizes="(min-width: 721px) 164px"
              />
              <source media="(max-width: 720px)" srcSet={`${env.MEDIA_URL}/static-images/logo-mobile.svg 87w`} sizes="(max-width: 720px) 87px" />
              <img width="87" height="48" src="" alt="Logo Wilderness International" />
            </picture>
          </a>
        </div>
        <div>
          <nav>
            <ul className="aw_fixed" id="main_menu">
              <li className="aw_menu_item aw_search aw_custom_item">
                {/* <a href="#">
                    <i className="aw_icon"></i>
                  </a> */}
                <div className="converter-buttons">
                  <div className="btn-converter btn-language">
                    <Dropdown
                      value={language}
                      options={languages}
                      onChange={onLanguageChange}
                      optionLabel="name"
                      valueTemplate={itemTemplateCustom(false)}
                      itemTemplate={itemTemplateCustom(false)}
                      className="dropdown-language"
                      placeholder="Select a language"
                      appendTo={'self'}
                    />
                  </div>
                </div>
              </li>
              <li className="aw_menu_item aw_donate aw_custom_item">
                <a
                  className="aw_icon_gift link_mode_hide_false"
                  style={{ minWidth: '160px' }}
                  href={header?.buttonUrl?.de === '#' || !header?.buttonUrl?.de ? env.REGION_URL : header?.buttonUrl?.de}
                >
                  {header?.urlName?.de ?? t('protect_forest')}
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="aw_mobile_nav_visible">
          <div className="converter-buttons">
            <div className="btn-converter btn-language">
              <Dropdown
                value={language}
                options={languages}
                onChange={onLanguageChange}
                optionLabel="name"
                valueTemplate={itemTemplateCustom(true)}
                itemTemplate={itemTemplateCustom(true)}
                className="dropdown-language"
                placeholder="Select a language"
                appendTo={'self'}
              />
            </div>
          </div>
          <a
            className="aw_btn aw_secondary aw_small aw_custom_icon aw_no_icon  link_mode_hide_false"
            href={header?.buttonUrl?.de === '#' || !header?.buttonUrl?.de ? env.REGION_URL : header?.buttonUrl?.de}
          >
            {/* {header?.urlName?.de ?? content?.protect_forest} */}
            {header?.urlName?.de ?? t('protect_forest')}
          </a>
        </div>

        {/* <button id="abw_mobile_menu" className="aw_no_style mr_mobile_24">
            <div className="aw_close_btn">
              <div className="aw_bar_one"></div>
              <div className="aw_bar_two"></div>
              <div className="aw_bar_three"></div>
            </div>
          </button> */}
      </div>
    </header>
  );
};

export default withTranslation('language')(Header);
